import { Link } from "react-router-dom";
import { DataKeys } from "../../types";
import { useLang } from "../Context";
import { SpacingFrame } from "../display/Frame";
import { HealthSection } from "../health/HealthSection";
import { getLocalized, HealthLang } from "../health/healthTypes";
import {
    HEALTH_CTA_BAND_BG,
    healthCtaBand,
    healthCtaButton,
    healthCtaSecondaryButton,
    healthCtaSubtitle,
    healthCtaTitle,
    healthFocusVisible,
} from "../health/healthVisualStyles";
import { educationLocalePath } from "./educationLocalePath";

interface EducationPrimaryCtaProps {
    data: DataKeys;
}

export function EducationPrimaryCta({ data }: EducationPrimaryCtaProps) {
    const { lang } = useLang();
    const hLang = lang as HealthLang;
    const href = educationLocalePath((data?.href as string) ?? "/contact-us", hLang);
    const secondaryHref = educationLocalePath(
        (data?.secondaryHref as string) ?? "/education/medical-sensei",
        hLang
    );

    return (
        <HealthSection id="cta" compact style={{ backgroundColor: HEALTH_CTA_BAND_BG }}>
            <div className={healthCtaBand}>
                <SpacingFrame spacing={32} center>
                    <div className="flex w-full min-w-0 flex-col gap-2 text-left lg:items-center lg:text-center">
                        <h2 className={healthCtaTitle}>
                            {getLocalized(data?.title, hLang)}
                        </h2>
                        <p className={healthCtaSubtitle}>
                            {getLocalized(data?.subtitle, hLang)}
                        </p>
                    </div>
                    <div className="flex w-full flex-col gap-3 lg:w-auto lg:flex-row lg:justify-center">
                        <Link to={href} className={`${healthCtaButton} ${healthFocusVisible}`}>
                            {getLocalized(data?.ctaLabel, hLang)}
                        </Link>
                        {getLocalized(data?.secondaryLabel, hLang) && (
                            <Link
                                to={secondaryHref}
                                className={`${healthCtaSecondaryButton} ${healthFocusVisible}`}
                            >
                                {getLocalized(data?.secondaryLabel, hLang)}
                            </Link>
                        )}
                    </div>
                </SpacingFrame>
            </div>
        </HealthSection>
    );
}
